import { useState } from 'react';
import type { ActivityDescription } from '../../../lib/taskActivityText';

/**
 * The long part of an audit line — a comment's text, a description before and
 * after — quoted under the sentence. Clamped to a few lines; click to expand.
 * A removed value is struck through, so "what was deleted" reads at a glance.
 */
export function ActivityDetail({ detail }: { detail: NonNullable<ActivityDescription['detail']> }) {
  const before = detail.before?.trim() || null;
  const after = detail.after?.trim() || null;
  if (!before && !after) return null;
  const both = Boolean(before && after);
  return (
    <div className="mt-1 space-y-1">
      {before && <Quote label={both ? 'Înainte' : null} text={before} removed />}
      {after && <Quote label={both ? 'După' : null} text={after} />}
    </div>
  );
}

function Quote({
  label,
  text,
  removed = false,
}: {
  label: string | null;
  text: string;
  removed?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const long = text.length > 220 || text.split('\n').length > 3;
  return (
    <div className="border-l-2 border-gray-200 pl-2.5">
      {label && <div className="text-[11px] font-medium text-gray-400">{label}</div>}
      <p
        className={`whitespace-pre-wrap break-words text-[12.5px] ${
          removed ? 'text-gray-400 line-through decoration-gray-300' : 'text-gray-600'
        } ${long && !open ? 'line-clamp-3' : ''}`}
      >
        {text}
      </p>
      {long && (
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="text-[11.5px] text-gray-400 hover:text-gray-700"
        >
          {open ? 'Arată mai puțin' : 'Arată tot'}
        </button>
      )}
    </div>
  );
}
